/* each key matches a serrch filter id
 * this is not a scalable way to do this,
 * ideally the links should be set in the backend as system vars
 */

export const links = [
  {
    SearchFilterId: 1,
    Name: "SLEEP & TIREDNESS",
        primaryVid: "https://player.vimeo.com/video/709220318?h=f048a080f9",
        secondaryVid: "https://player.vimeo.com/video/709220496?h=9a799de799"
  },
  {
    SearchFilterId: 2,
    Name: "RETAINING & RECALLING INFORMATION",
      primaryVid: "https://player.vimeo.com/video/709220034?h=7208904660" ,
      secondaryVid: "https://player.vimeo.com/video/709220043?h=bbb5b64bb8"
  },
  {
    SearchFilterId: 3,
    Name: "EXAM ANXIETY",
      primaryVid: "https://player.vimeo.com/video/708357401?h=6c77115693",
      secondaryVid: "https://player.vimeo.com/video/708356452?h=4ad22fce08"
  },
  {
    SearchFilterId: 4,
    Name: "FOCUS & MOTIVATION",
      primaryVid:"https://player.vimeo.com/video/708357546?h=bf2c6c5c50",
      secondaryVid: "https://player.vimeo.com/video/708356601?h=0b0a50b8e8"
  },
  {
    SearchFilterId: 5,
    Name: "ORGANIZATION & TIME MANAGEMENT",
      primaryVid: "https://player.vimeo.com/video/709213219?h=6ac27cc0d1",
      secondaryVid: "https://player.vimeo.com/video/709213199?h=397b6dceed"
  },
  {
    SearchFilterId: 6,
    Name: "STRESS & STRAIN",
      primaryVid: "https://player.vimeo.com/video/708357401?h=6c77115693",
      secondaryVid: "https://player.vimeo.com/video/708356452?h=4ad22fce08",
  },
  {
    SearchFilterId: 7,
    Name: "CONFIDENCE",
      primaryVid: "https://player.vimeo.com/video/708357165?h=21003dc86e",
      secondaryVid: "https://player.vimeo.com/video/708356205?h=16c4c77924",
  },
];



// WEBPACK FOOTER //
// ./src/pages/Home/courseVideosLinks.js